export class AwsRestoreAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "metricsConfigRegion",
            "baseName": "metricsConfigRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "grantedServices",
            "baseName": "grantedServices",
            "type": "AwsGrantedServices",
            "format": ""
        },
        {
            "name": "services",
            "baseName": "services",
            "type": "AwsRestoreServices",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsRestoreAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
